import { useCallback, useState } from 'react';
import { mergeFeed, removeFeedByPrefix, type FeedEntry } from './feed';

/**
 * A capped, newest-first feed; `push` ignores empty batches (no re-render) and
 * `drop` removes the entries whose id starts with a prefix.
 */
export function useFeed(): [FeedEntry[], (fresh: FeedEntry[]) => void, (prefix: string) => void] {
  const [entries, setEntries] = useState<FeedEntry[]>([]);
  const push = useCallback((fresh: FeedEntry[]) => {
    if (fresh.length > 0) setEntries((prev) => mergeFeed(prev, fresh));
  }, []);
  const drop = useCallback((prefix: string) => setEntries((prev) => removeFeedByPrefix(prev, prefix)), []);
  return [entries, push, drop];
}
